// controllers/RXController.ts
import { OptimisticObservable } from "@adornis/base/rxjs-extension/index.js";
import { BehaviorSubject, Observable, from, pairwise, shareReplay, startWith, tap } from "rxjs";
import { loaderSymbol } from "../symbols.js";
import "./chemistry-controller.js";
var makeRXControllerSource = (input) => input instanceof Promise ? from(input) : input instanceof Observable ? input : new BehaviorSubject(input);
var RXController = class {
  constructor(host, input, pipe, { pipeIsLoading = true, useLoaderController } = {}) {
    this.isLoading = true;
    this.host = host;
    const source = makeRXControllerSource(input);
    this.sourceIsNextable = "next" in source && typeof source.next === "function";
    this.source = source;
    if (this.isOptimistic = source instanceof OptimisticObservable && !pipe) {
      source.isLoading.subscribe((loading) => this._setLoading(loading));
    }
    const observableSource = pipeIsLoading && !!pipe ? source.pipe(tap(() => this._setLoading(true))) : source;
    const pipedObservable = pipe ? pipe(observableSource) : observableSource;
    const finalObservable = this.isOptimistic ? pipedObservable : pipedObservable.pipe(tap(() => this.isLoading = false));
    this.observable = finalObservable.pipe(shareReplay({ bufferSize: 1, refCount: true }));
    if (useLoaderController)
      this.host[loaderSymbol]?.waitFor(this.observable);
    this.host.addController(this);
  }
  get propertyName() {
    if (!this._propertyName) {
      let propertyName = void 0;
      for (const propName in this.host) {
        if (this.host[propName] === this) {
          propertyName = propName;
          break;
        }
      }
      if (propertyName) {
        if (propertyName.startsWith("__"))
          propertyName = propertyName.replace(/^__/, "");
        this._propertyName = propertyName;
      }
    }
    return this._propertyName;
  }
  next(value) {
    if (!this.sourceIsNextable)
      throw new Error("called next on a RXController with not nextable source!");
    this.source.next(value);
  }
  startSubscription() {
    return this.observable.pipe(startWith(void 0), pairwise()).subscribe(([oldValue, val]) => {
      this.value = val;
      this.host.requestUpdate(this.propertyName, oldValue);
    });
  }
  hostConnected() {
    if (!this.subscription)
      this.subscription = this.startSubscription();
  }
  hostDisconnected() {
    if (this.subscription)
      this.subscription.unsubscribe();
    this.subscription = void 0;
  }
  _setLoading(loading) {
    if (this.isLoading === loading)
      return;
    this.isLoading = loading;
    this.host.requestUpdate();
  }
};
export {
  RXController
};
